import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
export const getPartnerPaymentDetails = (mpacBaseUrl, partnerId, options = {}) => fetchOk("".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/paymentInfo"), { ...options
}).then(response => response.json());
export const updatePartnerPaymentDetails = (mpacBaseUrl, partnerId, paymentDetails) => fetchOk("".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/paymentInfo"), {
  method: 'PUT',
  body: JSON.stringify(paymentDetails),
  headers: {
    'Content-Type': 'application/json'
  }
});